module.exports = __webpack_public_path__ + "static/media/Logo_MA_Grey.8dd6e20e.png";